<template>
  <div class="box">
    <div class="top_title">
      <i class="top_icon"></i>
      <span class="top_mess">松山智慧停车</span>
    </div>
    <div class="top_img"></div>
    <div class="main">
      <!-- <div class="main_img"><div></div></div> -->
      <div class="main_mess">
        <div>松山智慧停车</div>
        <p>
          松山智慧停车系统，是松山区政府投资建设项目，主要负责赤峰市松山区城区新建停车场（包括公共停车场、道路路缘石至两侧合法建筑物之间的区域停车泊位等）的建设、运营管理及研发智慧停车管理系统等工作。深入研究智慧停车产业发展模式，始终坚持以科技赋能、创新发展智慧停车产业为切入点，深耕松山区城区停车资源，努力推动高质量泊位供给、多元化运营模式和数据共享创新理念有机结合。为实现“智能”提升，松山智慧停车搭建起了可容纳松山区城区停车资源的“智慧停车管理系统”，并依托系统推出了“玉龙出行”APP、小程序，通过移动端进行松山区城区剩余停车泊位查询、停车诱导、自助缴费等操作，推动了停车信息向互联网融合发展方向转变，构建了松山区城区智慧停车的管理格局。
        </p>
      </div>
    </div>
    <div class="imgAll">
      <div class="left">
        <p class="bottom_title">
          松山智慧停车APP下载
        </p>

        <div class="btn-group">
          <a
            class="btn-item"
            href="https://apps.apple.com/cn/app/%E5%A4%A9%E6%B4%A5%E6%99%BA%E8%81%94%E5%81%9C%E8%BD%A6/id6443934352"
            ><img src="../components/img/ios.png" alt=""
          /></a>

          <a
            class="btn-item"
            href="http://app.cfylcx.com/app/AiPark_cf.apk"
            style="margin:0 auto;"
            ><img src="../components/img/android.png" alt=""
          /></a>
        </div>
        <!-- <div class="bottom_img"></div>
        <p class="bottom_title">0
          <a href="https://wechat.ts.aipark.com/dlApp?v=1.0"
            >天津市智联停车APP下载</a
          >
        </p> -->
      </div>
      <!-- <div class="bott_riImg"><div style="width:100%"></div></div> -->
    </div>
    <div class="bottom">
      <div style="width:600px;margin:0 auto; padding:20px 0;">
        <a
          target="_blank"
          href="https://beian.miit.gov.cn/#/Integrated/index"
          style="display:inline-block;text-decoration:none;height:20px;line-height:20px;"
        >
          <p
            style="float:left;height:20px;line-height:20px;margin: 0px 10px 0px 5px; color:#939393;"
          >
            蒙ICP备 2022003818号 -1
          </p>
        </a>

        <a
          target="_blank"
          href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=15040402000318"
          style="display:inline-block;text-decoration:none;height:20px;line-height:20px;"
        >
          <img src="./img/badge.png" style="float:left;" />
          <p
            style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;"
          >
            蒙公网安备 15040402000318号
          </p>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  name: "m_index",
  data() {
    return {
      msg: "Welcome to Your Vue.js App"
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
a {
  text-decoration: none;
  display: inline-block;
  margin: 0 40px;
}
.left {
  margin-top: 100px;
}
.top_title {
  width: 100%;
  background: #000000;
  opacity: 0.4;
  height: 130px;
  position: fixed;
  top: 0;
  left: 0;
}
.top_mess {
  float: left;
  display: inline-block;
  height: 130px;
  line-height: 130px;
  color: #ffffff;
  font-size: 30px;
  font-weight: bold;
  margin-left: 30px;
}
.top_icon {
  display: inline-block;
  width: 100px;
  height: 100px;
  background: url("./img/logo.png");
  background-size: 100% 100%;
  margin: 15px 0 15px 50px;
  float: left;
}
.top_img {
  width: 100%;
  height: 400px;
  background: url("./img/titleImg.png") no-repeat;
  background-size: 100% 100%;
}
.main {
  width: 100%;
}
.main_img {
  width: 50%;
  height: 100%;
  float: left;
  margin: 20px auto;
  display: flex;
  align-items: center;
}
.main_img div {
  margin: 20px auto;
  width: 980px;
  height: 550px;
  background: url("./img/leftImg.png") no-repeat;
  background-size: 100% 100%;
}
.main_mess {
  padding: 0 20px 0;
}
.main_mess div {
  font-size: 40px;
  text-align: center;
  padding-top: 40px;
}
.main_mess p {
  font-size: 20px;
  text-align: center;
  text-indent: 20px;
}
.bottom_img {
  width: 300px;
  margin: 100px auto 0;
  height: 300px;
  background: url("./img/go.png") no-repeat;
  background-size: 100% 100%;
}
.bottom {
  width: 100%;
  height: 130px;
  background: #000000;
  color: #ffffff;
  text-align: left;
  line-height: 130px;
  position: fixed;
  bottom: 0;
  left: 0;
}
.bottom_title {
  font-size: 30px;
  font-weight: bold;
  padding-top: 20px;
}

.bott_riImg div {
  display: flex;
  align-items: center;
  width: 750px;
  height: 600px;
  background: url("./img/bottom-rightImg.png") no-repeat;
  background-size: 100% 100%;
}
.imgAll {
  width: 100%;
}
.btn-item img {
  display: block;
  box-sizing: border-box;
  height: 46px;
  width: 150px;
  border-radius: 5px;
  font-size: 12px;
  position: relative;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/m_index.vue